import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { areas, images } from "@/config/site";
import { SEO, breadcrumbLd } from "@/lib/seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CTA } from "@/components/CTA";

export default function Areas() {
  return (
    <>
      <SEO
        title="Service Areas | Painters in Delta, Ladner, Tsawwassen & Surrey BC"
        description="North Ember Painting serves Delta, Ladner, Tsawwassen and Surrey, BC with professional interior, exterior, cabinet and commercial painting. Free estimates."
        path="/service-areas"
        jsonLd={[breadcrumbLd([{ name: "Home", path: "/" }, { name: "Service Areas", path: "/service-areas" }])]}
      />
      <PageHero
        eyebrow="Service areas"
        title="Local painters for the South Fraser region"
        intro="Based in North Delta, we paint homes and businesses across Delta, Ladner, Tsawwassen and Surrey — communities we know street by street."
        image="neighbourhoodDelta"
      />
      <section className="py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            {areas.map((a, i) => (
              <Reveal key={a.slug} delay={(i % 2) * 80}>
                <Link
                  to={`/service-areas/${a.slug}`}
                  data-testid={`area-card-${a.slug}`}
                  className="tilt-card group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:border-ember/40 hover:shadow-xl"
                >
                  <div className="aspect-[16/8] overflow-hidden">
                    <img src={images[a.image].url} alt={images[a.image].alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  </div>
                  <div className="flex flex-1 flex-col p-7">
                    <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-ember">
                      <MapPin className="h-3.5 w-3.5" aria-hidden="true" /> {a.name}, BC
                    </span>
                    <h2 className="mt-2 font-display text-2xl font-semibold tracking-tight text-slate-900">{a.title}</h2>
                    <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">{a.intro[0]}</p>
                    <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-ember-dark transition-colors duration-200 group-hover:text-ember">
                      Painting in {a.name} <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-12">
            <p className="max-w-2xl text-sm leading-relaxed text-slate-500">
              Just outside these areas? Reach out anyway — depending on the project and schedule, we may be able
              to help or recommend someone closer to you.
            </p>
          </Reveal>
        </div>
      </section>
      <CTA />
    </>
  );
}
